export const version = '0.721.0'
export const chameleonWebVersion = '7.2.1'
export const chameleonCoreVersion = '6.6.0'
